/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from 'react';
import { useAppContext } from '../context/context';
import instanceAxios from '../util/axios';

type result = {
  data: any;
  error: any;
  loading: boolean;
  fetchData: (payload: payload) => Promise<any>;
  setDataResult: (data: any) => void;
};

type payload = {
  data?: any;
  url: string;
  method: string;
};

export const useFetch = (defaultLoading = false): result => {
  const [data, setDataResult] = useState(null);
  const [loading, seLoading] = useState(defaultLoading);
  const [error, setError] = useState<unknown>(null);
  const { setSnackbar } = useAppContext() || { setSnackbar: () => null };

  const fetchData = useCallback(
    async (request: payload) => {
      seLoading(true);

      const { url, method, data: dataReuest } = request;
      const payload: payload = { url, method };

      if (dataReuest) {
        payload.data = dataReuest;
      }

      try {
        const response = await instanceAxios(payload);
        setDataResult(response.data);
        return response.data;
      } catch (err) {
        setError(err);
        url.includes('auth') ? null : setSnackbar({ message: 'שגיאה בעת טעינת נתונים', severity: 'error', open: true });
        throw err;
      } finally {
        seLoading(false);
      }
    },
    [setSnackbar]
  );

  return { data, setDataResult, error, loading, fetchData };
};
